interface list {
    title: string;
    info: string;
}
interface infoList {
    allTitle: string;
    img: string;
    list: list[];
}
interface ModelTitle {
    title: string;
    desc: string;
}
interface ModelContentData {
    info: infoList[];
    modelTitle: ModelTitle;
}


const modelContentData =(activeTab: number): ModelContentData => {
    let info: any[] = [];
    let modelTitle: ModelTitle = {
        title: '',
        desc: '',
    }
    const CustomerProfileList = [
        {
            title:'Phone Number',
            info:''
        },
        {
            title:'Booking Code',
            info:''
        },
        {
            title:'Name',
            info:''
        },
    ]
    const ProductTypeList = [
        {
            title:'Arrival Date',
            info:''
        },
        {
            title:'Time Slot',
            info:''
        },
        {
            title:'Visitors',
            info:''
        }
    ]
    if(activeTab === 1){
        info = [
            {
                allTitle:'Customer Profile',
                img:require('../../../../assets/appointmentManagement/dashboard/profile.png'),
                list:CustomerProfileList
            },
            {
                allTitle:'Lounge',
                img:require('../../../../assets/appointmentManagement/dashboard/lounge.png'),
                list:ProductTypeList
            }
        ]
        modelTitle = {
            title:'Confirm to redeem this booking?',
            desc:'Please check in the booking for this time slot.',
        }
    }else if(activeTab === 2){
        info = [
            {
                allTitle:'Customer Profile',
                img:require('../../../../assets/appointmentManagement/dashboard/profile.png'),
                list:CustomerProfileList
            },
            {
                allTitle:'Meeting Room',
                img:require('../../../../assets/appointmentManagement/dashboard/meetingRoom.png'),
                list:ProductTypeList
            }
        ]
        modelTitle = {
            title:'Verify Reservation Details',
            desc:'Please check in the booking for this time slot.',
        }
    }else if(activeTab === 3){
        info = [
            {
                allTitle:'Customer Profile',
                img:require('../../../../assets/appointmentManagement/dashboard/profile.png'),
                list:CustomerProfileList
            },
            {
                allTitle:'Safe Box',
                img:require('../../../../assets/appointmentManagement/dashboard/vault.png'),
                list:ProductTypeList
            }
        ]
        modelTitle = {
            title:'Verify Reservation Details',
            desc:'Please check in the booking for this time slot.',
        }
    }
    return {
        info,
        modelTitle,
    }
}
export default modelContentData;
